import { BasicModal } from '../../components/Modal/BasicModal';
import { CREATE_ANONYMOUS } from '../../state/mutations/User';
import { IReckoningModel } from '../../state/stores/Reckoning/ReckoningModel';
import { IS_RECKONING_AVAILABLE } from '../../state/queries/Reckonings';
import { client } from '../../config/apollo/client';
import { concatPath } from '../../utils/links/concatPath';
import { dashboardKey, publicKey, thankYouKey } from '../../constants/routeKeys';
import { loginKey, registerKey } from '../../constants/routeKeys';
import { router } from 'expo-router';
import { useEffect, useState } from 'react';
import { useManageToken } from './useManageToken';
import { useMutation } from '@apollo/client';
import { useStores } from '../useStores';


export const useCreateAnonymousUser = (reckoningId: string) => {
  const [createAnonymous] = useMutation(CREATE_ANONYMOUS);
  const rootStore = useStores();
  const manageToken = useManageToken(()=>{});
  const reckoning: IReckoningModel = rootStore.reckoning.getReckoning(reckoningId);
  const [modalNotAvailableVisibility, setModalNotAvailableVisibility] = useState<boolean>(false);
  const [modalNeedRedirectionVisibility, setModalNeedRedirection] = useState<boolean>(false);
  const labels = rootStore?.language.translate.MOBILE?.SESSION;
  const [canBeCreated, setCanBeCreated] = useState<boolean>(true);

  const goToThankYou = () => {
    router.navigate(concatPath([thankYouKey]) as string);
  };

  const goToRegister = () => {
    router.navigate(concatPath([publicKey, registerKey],-1) as string);
  };

  const goToLogin = () => {
    router.navigate(concatPath([publicKey, loginKey],-1) as string);
  };

  const goToDashboard = () => {
    router.navigate(concatPath([dashboardKey]) as string);
  };

  const createAnonymousUser = async (reckoning: IReckoningModel) => {

    if(reckoning && reckoning.allowAnonymousUser) {
      const {data} = await createAnonymous({
        variables: {
          reckoning: reckoningId
        }
      });

      if(data && 'createAnonymous' in data) {
        manageToken(data['createAnonymous'] as string, true);
      }
    } else {
      setCanBeCreated(false);
    }
  };

  const checkIfReckoningisAvailable = async (reckoningId: string) => {
    const {data} = await client.query({ query: IS_RECKONING_AVAILABLE , variables: {reckoning: reckoningId}, fetchPolicy: 'no-cache'});
    if(data && 'isReckoningAvailable' in data && !data['isReckoningAvailable']) {
      setModalNotAvailableVisibility(true);
    }
  };


  const manageInitFromReckoning = async () => {

    const reckoning = await rootStore.reckoning.fetchReckoningIfNotExist(reckoningId, !rootStore?.user?.user);

    if(!reckoning) {
      setModalNotAvailableVisibility(true);
    } else {
      if(rootStore?.user?.user) {
        checkIfReckoningisAvailable(reckoningId);
        if(rootStore?.user?.anonymous) {
          if(!reckoning.allowAnonymousUser) {
            if(reckoning?.allowRegistration) {
              setModalNeedRedirection(true);
            } else {
              goToThankYou();
            }
          } else if(reckoning.alreadyDone) {
            setModalNotAvailableVisibility(true);
          }
        }
      } else {
        if(reckoning.allowAnonymousUser) {
          createAnonymousUser(reckoning);
        } else {
          goToRegister();
        }
      }

    }
  };

  useEffect(() => {
    if(reckoningId) {
      manageInitFromReckoning();
    }
    return () => {
      if(reckoningId && rootStore?.user?.anonymous) {
        rootStore.session?.deleteSessionData();
        rootStore.reckoning.clear();
        // rootStore.user.setGDPRNotAccepted();
      }
    };
  }, []);

  const modalNotAvailable = () => {
    return(
      <BasicModal isVisible={modalNotAvailableVisibility} onDismiss={() => {
        setModalNotAvailableVisibility(false);
        if(rootStore.user?.anonymous) {
          if(!reckoning || reckoning?.allowRegistration) {
            goToRegister();
          } else {
            goToThankYou();
          }
        } else {
          if(rootStore.user.user) {
            goToDashboard();
          } else {
            goToLogin();
          }
        }
      }}
      mainText= {labels?.NOT_AVAILABLE_TEXT}
      buttonText={labels?.NOT_AVAILABLE_BUTTON?labels?.NOT_AVAILABLE_BUTTON:'OK'}
      />);
  };

  const modalNeedRedirection = () => {
    return(<BasicModal isVisible={modalNeedRedirectionVisibility} onDismiss={() => {
      setModalNeedRedirection(false);
      goToRegister();
    }}
    mainText= {labels?.NEED_REDIRECTION}
    buttonText={labels?.NEED_REDIRECTION_BUTTON}
    />);
  };

  return {modalNotAvailable, modalNeedRedirection, canBeCreated};


};

